import { utils } from "./utils";

class DateUtils {
    adquirirIntervaloDeHoje() {
        let hoje = utils.formatarCampoDataParaEnvioAoBackendSemHora(new Date());
  
        return {
          dataInicial: hoje,
          dataFinal: hoje
        };
      }
  
      adquirirIntervaloSemana() {
        let hoje = new Date();
        const primeiroDia = hoje.getDate() - hoje.getDay();
        const ultimoDia = primeiroDia + 6;
        
        const primeiroDiaFormatado = new Date(hoje.setDate(primeiroDia)).toUTCString();
        hoje = new Date();
        const ultimoDiaFormatado = new Date(hoje.setDate(ultimoDia)).toUTCString();
  
        return {
          dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDiaFormatado),
          dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDiaFormatado)
        };
      }
  
      adquirirIntervaloMes() {
        const hoje = new Date();
        const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
  
        return {
          dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDia),
          dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDia)
        };
      }
}

export const dateUtils = new DateUtils();